// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"201":"12c976c7","669":"f5e063ad","887":"6a205f26"}[chunkId] + ".css";
};